import axios from "../../../api/axios";

export const getAllProjects = async (accessToken) => {
  const response = await axios.get(
    `/project/all/${process.env.REACT_APP_CLIENT_NAME}`,
    { headers: { authorization: `Bearer ${accessToken}` } }
  );
  const modifiedRes = response.data.map((res) => ({
    ...res,
    members: res["project_members"],
  }));

  return modifiedRes;
};
